import React from 'react';
import { BrowserRouter as Router, Route, Redirect, Switch } from 'react-router-dom';
import Admin from './scenes/Admin/Admin';
import Landing from './scenes/Landing/Landing';
import Dashboard from './scenes/Dashboard/Dashboard';
import Organisation from './scenes/Organisation/Organisation';
import EmailConfirmation from './scenes/EmailConfirmation';
import EmailInvitation from './scenes/EmailInvitation';
import EmailUpdate from './scenes/EmailUpdate';
import ResetPassword from './scenes/ResetPassword';
import AuthenticatorRecovery from './scenes/AuthenticatorRecovery';
import ContactUs from './scenes/ContactUs/ContactUs';
import Purchase from './scenes/Purchase/Purchase';
import PurchasePayPalCallback from './scenes/Purchase/components/PurchasePayPalCallback';
import AdminLogin from './scenes/AdminLogin/AdminLogin';
import OnboardingRegistration from './scenes/Onboarding';
import NotFound from './scenes/404';
import { ErrorTest } from './scenes/ErrorTest/ErrorTest';
import Tracker from './components/Tracker/Tracker';
import ScrollToTop from './components/ScrollToTop/ScrollToTop';
import { secureStorage } from './utils/secureStorage';
import { isPurchaseEnabled } from './utils/featureGates';

const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={(props) =>
      secureStorage.getItem('token') ? (
        <Component {...props} />
      ) : (
        <Redirect to={{ pathname: '/', state: { from: props.location } }} />
      )
    }
  />
);

const purchaseEnabled = isPurchaseEnabled();

export default () => (
  <Router>
    <ScrollToTop />
    <Tracker />
    <Switch>
      <Route exact path="/" component={Landing} />
      <Route path="/admin-login" component={AdminLogin} />
      <PrivateRoute path="/dashboard" component={Dashboard} />
      <PrivateRoute path="/admin" component={Admin} />
      <PrivateRoute path="/organization" component={Organisation} />
      <Route path="/confirmation/email" component={EmailConfirmation} />
      <Route path="/invitation/email" component={EmailInvitation} />
      <Route path="/update-email" component={EmailUpdate} />
      <Route path="/reset-password" component={ResetPassword} />
      <Route path="/authenticator-recovery" component={AuthenticatorRecovery} />
      <Route path="/onboarding/registration" component={OnboardingRegistration} />
      <Route
        path="/onboardding/registration"
        render={({ location }) => (
          <Redirect to={{ pathname: '/onboarding/registration', search: location.search }} />
        )}
      />
      <Route path="/contact-us" component={ContactUs} />
      <Route path="/error-test" component={ErrorTest} />
      {purchaseEnabled ? (
        <Route
          path="/onboarding/paypal/return"
          render={(props) => <PurchasePayPalCallback {...props} mode="return" />}
        />
      ) : null}
      {purchaseEnabled ? (
        <Route
          path="/onboarding/paypal/cancelled"
          render={(props) => <PurchasePayPalCallback {...props} mode="cancelled" />}
        />
      ) : null}
      {purchaseEnabled ? <Route path="/purchase" component={Purchase} /> : null}
      <Route component={NotFound} />
    </Switch>
  </Router>
);
